module.exports = __webpack_public_path__ + "img/img_out_offering_fixed_in2021.2e1539bd.png";